import { defineMessages } from 'react-intl-next';
export default defineMessages({
    ssoTestModeInlineMessageTitle: {
        defaultMessage: 'You are in single sign-on test mode',
        description: 'Message title for inline message when in test mode in the login screen',
        id: 'cv.login.test.mode.inline.message.title',
    },
    ssoTestModeInlineMessageContent: {
        defaultMessage:
            'You are using a unique URL to test single sign-on. To return to your regular site, <a>exit test mode</a>.',
        description: 'Message content for inline message when in test mode in the login screen',
        id: 'cv.login.test.mode.inline.message.content',
    },
});
